export default "__VITE_ASSET__BqSL14az__"